import { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { yellow } from '@mui/material/colors';
import { faCircleExclamation, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { WhiteInput } from "../Inputs/InputText";
import { BlueHoverButton } from "../Inputs/BlueHoverButton";
import { GoogleMap, Marker, Polyline, InfoWindowF } from "@react-google-maps/api";
import { Dialog, DialogTitle, DialogContent, DialogActions, Snackbar, Alert, Box, CircularProgress, InputLabel, Modal, Tooltip, FormControl } from "@mui/material";
import servConsultaDisponibilidade from "../../services/login/servConsultaDisponibilidade";
import MapaDrawingManager from "./MapaDrawingManager/MapaDrawingManager";
import { style as modalstyle } from "../Loading/Loading";
import { debounce } from 'lodash';
import { FaDrawPolygon, FaHandPaper } from "react-icons/fa";
import { TbMapX } from "react-icons/tb";
import { GrSearch } from "react-icons/gr";
import { CiUndo } from "react-icons/ci";
import './MapaDrawing.css';
import servOcupante from "../../services/login/servOcupante";
import { OcupantesSearchField } from "../Searchfields/Ocupantes";


const MapaDrawing = ({
    parametros,
    coordenadasLatLong,
    showDrawing,
    setCoordenadasLatLong,
    mapaLoaded,
    setMapaLoaded,
    isLegenda = true,
    containerStyle
}) => {
    const [searchAddress, setSearchAddress] = useState("");
    const [open, setOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const infoWindowRef = useRef(null);
    const [poligono, setPoligono] = useState([]);
    const drawingManagerRef = useRef(null);
    const polygonRef = useRef(null);
    const [pontosMapa, setPontosMapa] = useState([]);
    const [redesMapa, setRedesMapa] = useState([]);
    const [hoveredDescricao, setHoveredDescricao] = useState(null);
    const [hoveredPosition, setHoveredPosition] = useState(null);
    const mapRef = useRef(null);
    const circlesRef = useRef(new Map());
    const zoomAnimationFrame = useRef(null);
    const [currentZoom, setCurrentZoom] = useState(12);
    const polylinesRef = useRef([]);
    const [drawingManagerKey, setDrawingManagerKey] = useState(Date.now());
    const polyRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [modoAtivo, setModoAtivo] = useState('desenho');
    const [openDialogMessageClearMap, setOpenDialogMessageClearMap] = useState(false);
    const [ocupanteSelecionado, setOcupanteSelecionado] = useState(null);
    const [pontosBuscados, setPontosBuscados] = useState(false);
    const [markersKey, setMarkersKey] = useState(0);

    const handleSearch = async () => {
        if (!searchAddress.trim()) {
            return;
        }

        const geocoder = new window.google.maps.Geocoder();

        geocoder.geocode({ address: searchAddress, region: "BR" }, (results, status) => {
            if (status === "OK") {
                const location = results[0].geometry.location;
                const newPosition = { lat: location.lat(), lng: location.lng() };

                setCoordenadasLatLong(newPosition);

                if (mapRef.current) {
                    mapRef.current.setZoom(18);
                    mapRef.current.panTo(newPosition);
                }

            } else {
                setErrorMessage("Erro ao buscar endereço");
                setOpen(true);
                console.log("Erro ao buscar endereço");
                return;
            }
        });
    };

    const handleCloseDialog = () => {
        setOpenDialogMessageClearMap(false);
    };

    const handleClose = () => {
        setOpen(false);
        setErrorMessage("");
    };

    const getCircleRadius = (zoom) => {
        const baseRadius = 16;
        const zoomFactor = Math.pow(2, 15 - zoom);
        return Math.max(12, baseRadius * zoomFactor);
    };

    useEffect(() => {
        if (!mapRef.current || !circlesRef.current) return;

        const updateCircleSizes = debounce(() => {
            const newZoom = mapRef.current.getZoom();
            if (newZoom === currentZoom) return;
            setCurrentZoom(newZoom);

            const newRadius = getCircleRadius(newZoom);

            circlesRef.current.forEach((circle) => {
                if (circle?.setRadius) {
                    circle.setRadius(newRadius);
                }
            });
        }, 100);

        const zoomListener = mapRef.current.addListener('zoom_changed', updateCircleSizes);

        updateCircleSizes();

        return () => {
            if (zoomListener) {
                window.google.maps.event.removeListener(zoomListener);
            }
        };
    }, [mapaLoaded]);

    const getColorForType = (tipo) => {
        const colorMap = {
            1: "#FFFF00",
            2: "#008000",
            3: "#FF0000",
            4: "#FF8C00",
            5: "#8B0000",
        };
        return colorMap[tipo] || "#3e3e3e";
    };

    const handleZoomChanged = () => {
        if (!mapRef.current) return;

        const newZoom = mapRef.current.getZoom();
        setCurrentZoom(newZoom);

        const newRadius = getCircleRadius(newZoom);

        circlesRef.current.forEach((circle) => {
            if (circle && circle.setRadius) {
                circle.setRadius(newRadius);
            }
        });
    };

    async function handleConsultarPontos(coordenadas) {
        try {
            if (!coordenadas) return;

            setIsLoading(true);

            const response = await servConsultaDisponibilidade.BuscarPontos(coordenadas);

            const { Pontos, Redes } = response.Content;

            if (Pontos.length === 0 && Redes.length === 0) {
                setErrorMessage("Nenhum ponto encontrado");
                setOpen(true);
                setIsLoading(false);

                if (polyRef.current) {
                    polyRef.current.setMap(null);
                    polyRef.current = null;
                }

                return;
            }

            setPontosMapa(prevPontos => [...prevPontos, ...Pontos]);
            setRedesMapa(prevRedes => [...prevRedes, ...Redes]);
            setPontosBuscados(true);
            setIsLoading(false);

            if (polyRef.current) {
                polyRef.current.setMap(null);
                polyRef.current = null;
            }
        }
        catch (err) {

            if (polyRef.current) {
                polyRef.current.setMap(null);
                polyRef.current = null;
            }

            setErrorMessage(err?.response?.data?.Message);
            setOpen(true);
            console.log(err);
            setIsLoading(false);
        }
    }

    function handleLimparMapa() {
        if (polygonRef.current) {
            polygonRef.current.setMap(null);
            polygonRef.current = null;
        }

        if (drawingManagerRef.current) {
            drawingManagerRef.current.setMap(null)
            drawingManagerRef.current.setDrawingMode(null);
        }

        if (polyRef.current) {
            polyRef.current.setMap(null);
            polyRef.current = null;
        }

        setPontosBuscados(false);
        setOcupanteSelecionado(null);
        setPoligono([]);
        setHoveredDescricao(null);
        setHoveredPosition(null);
        setPontosMapa([]);
        setRedesMapa([]);

        polylinesRef.current.forEach(polyline => polyline.setMap(null));
        polylinesRef.current = [];

        setDrawingManagerKey(Date.now());
        handleCloseDialog();
    }

    const ativarModoDesenho = () => {
        if (polyRef.current) {
            polyRef.current.setMap(null);
            polyRef.current = null;
        }

        setModoAtivo('desenho');
    };

    const ativarModoMao = () => {
        setModoAtivo('mao');
    };

    const handleUndoPonto = () => {
        if (polyRef.current) {
            const path = polyRef.current.getPath();
            if (path.getLength() > 0) {
                path.pop();
            }


            // const updatedCoordenadas = path.getArray().map((latLng, index) => ({
            //     NumeroPonto: index + 1,
            //     Latitude: latLng.lat().toString(),
            //     Longitude: latLng.lng().toString()
            // }));

            // if (updatedCoordenadas.length > 0) {
            //     updatedCoordenadas.push({
            //         NumeroPonto: updatedCoordenadas.length + 1,
            //         Latitude: updatedCoordenadas[0].Latitude,
            //         Longitude: updatedCoordenadas[0].Longitude,
            //     });
            // }

            // setPoligono(updatedCoordenadas);
        }
    };

    const handleOcupanteChange = (ocupante) => {
        setOcupanteSelecionado(ocupante);
        setMarkersKey(k => k + 1);
    };

    return (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={coordenadasLatLong}
            zoom={12}
            options={{ fullscreenControl: false }}
            onLoad={(map) => {
                mapRef.current = map;
                setMapaLoaded(true);
            }}
        >

            {pontosMapa.map((ponto, index) => {
                const isFull = parametros.QtdeMaximaDePontosPoste <= ponto.QtdeUsoMutuo;
                const doOcupante = ocupanteSelecionado?.CodigoUsoMutuo && ponto.UsosMutuos?.includes(ocupanteSelecionado.CodigoUsoMutuo);

                let corDoPoste;

                if (isFull && doOcupante) {
                    corDoPoste = 5;
                } else if (isFull) {
                    corDoPoste = 3;
                } else if (doOcupante) {
                    corDoPoste = 4;
                } else {
                    corDoPoste = 2;
                }

                return (
                    <Marker
                        key={`${markersKey}-${ponto.Lat}-${ponto.Lng}-${index}`}
                        position={{ lat: ponto.Lat, lng: ponto.Lng }}
                        icon={{
                            path: window.google.maps.SymbolPath.CIRCLE,
                            fillColor: getColorForType(corDoPoste),
                            fillOpacity: 0.8,
                            scale: 5,
                            strokeWeight: 1,
                        }}
                        options={{
                            fillColor: getColorForType(corDoPoste),
                            fillOpacity: 0.9,
                            strokeColor: 'transparent',
                            strokeOpacity: 0,
                            zIndex: 1000,
                            optimized: true
                        }}
                        onLoad={(circle) => {
                            if (!circlesRef.current) {
                                circlesRef.current = new Map();
                            }

                            circlesRef.current.set(index, circle);
                        }}
                        onUnmount={() => {
                            if (circlesRef.current) {
                                circlesRef.current.delete(index);
                            }
                        }}
                        onMouseOver={() => {
                            if (hoveredIndex !== index) {
                                setHoveredIndex(index);
                                setHoveredDescricao({
                                    Codigo: ponto.Codigo,
                                    Descricao: ponto.Descricao,
                                    QtdeEmUso: ponto.QtdeUsoMutuo
                                });
                                setHoveredPosition({ lat: ponto.Lat + 0.0001, lng: ponto.Lng });
                            }
                        }}
                        onMouseOut={() => {
                            setHoveredIndex(null);
                            setHoveredDescricao(null);
                            setHoveredPosition(null);
                        }}
                    />
                )
            })}

            {redesMapa
                .filter(rede => rede && Array.isArray(rede.Path) && rede.Path.length >= 2)
                .map((rede, index) => (
                    <Polyline
                        key={`${rede.TipoRede}-${index}`}
                        path={rede.Path.map(c => ({ lat: c.Lat, lng: c.Lng }))}
                        onLoad={(polyline) => {
                            polylinesRef.current = [...polylinesRef.current, polyline];
                        }}
                        options={{
                            strokeColor: rede.TipoRede === 1 ? "#000000" : "#808080",
                            strokeOpacity: 0.8,
                            strokeWeight: 3,
                            geodesic: true
                        }}
                    />
                ))}

            {hoveredPosition && (
                <InfoWindowF
                    position={hoveredPosition}
                    zIndex={20}
                    options={{
                        pixelOffset: new window.google.maps.Size(0, -8),
                        disableAutoPan: true
                    }}
                    onLoad={(iw) => {
                        infoWindowRef.current = iw;

                        const intervalId = setInterval(() => {
                            const container = iw.getContent()?.parentElement?.parentElement;
                            if (container) {
                                clearInterval(intervalId);

                                const closeButton = container.querySelector('.gm-ui-hover-effect');
                                if (closeButton) closeButton.remove();

                                const header = document.createElement('div');
                                header.style.display = 'flex';
                                header.style.justifyContent = 'space-between';
                                header.style.alignItems = 'center';
                                header.style.padding = '10px 12px';
                                header.style.background = '#fff';
                                header.style.color = 'black';

                                const title = document.createElement('div');
                                title.style.fontWeight = 'bold';
                                title.style.margin = '0px';
                                title.style.fontSize = '14px';
                                title.textContent = `Poste: ${hoveredDescricao.Codigo}`;

                                header.appendChild(title);

                                const content = iw.getContent();
                                if (content) {
                                    content.insertBefore(header, content.firstChild);
                                }
                            }
                        }, 10);

                        return () => clearInterval(intervalId);
                    }}
                    onCloseClick={() => {
                        setHoveredDescricao(null);
                        setHoveredPosition(null);
                    }}
                >
                    <div
                        style={{
                            fontSize: "14px",
                            padding: "12px",
                            minWidth: "200px",
                            backgroundColor: "white",
                            borderTop: ".4px dotted #e3e3e3",
                        }}
                    >
                        <div style={{ marginBottom: "6px" }}>
                            <span style={{ fontWeight: 500 }}>Característica: </span>
                            <span>{hoveredDescricao.Descricao}</span>
                        </div>
                        <div>
                            <span style={{ fontWeight: 500 }}>Em uso: </span>
                            <span>{hoveredDescricao.QtdeEmUso} / {parametros.QtdeMaximaDePontosPoste}</span>
                        </div>
                    </div>
                </InfoWindowF>
            )}

            {isLegenda && (<div
                style={{
                    position: "absolute",
                    top: "10px",
                    right: '20px',
                    width: '25%',
                    backgroundColor: "#343434",
                    borderRadius: "8px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                    zIndex: 2,
                    opacity: 0.9
                }}
            >
                <div style={{ display: "flex", alignItems: "center", padding: '8px 12px' }}>
                    <InputLabel sx={{ color: "#b8b8b8", fontSize: "12px", fontWeight: 600, marginRight: "10px" }}>
                        Informe aqui a localização no mapa
                    </InputLabel>
                    <Tooltip title="Necessário preencher o endereço conforme o exemplo para maior assertividade do mapa." arrow>
                        <div style={{ color: yellow[700], cursor: "pointer" }}>
                            <FontAwesomeIcon icon={faCircleExclamation} />
                        </div>
                    </Tooltip>
                </div>

                <div style={{ marginBottom: "10px", display: "flex", alignItems: "center", padding: '8px 12px' }}>
                    <WhiteInput
                        type="text"
                        placeholder="Ex: Rua Visc. de Cairú, 630, Criciúma - SC"
                        className='search-input'
                        style={{
                            flex: 1,
                            color: "white",
                            fontSize: "16px",
                            width: "340px"
                        }}
                        value={searchAddress}
                        onChange={(e) => setSearchAddress(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") handleSearch();
                        }}
                    />
                    <BlueHoverButton
                        onClick={handleSearch}
                        style={{
                            background: "#8166F5",
                            color: "white",
                            height: "45px",
                            borderRadius: "0px 10px 10px 0px",
                            border: "none",
                            borderLeft: "none",
                            padding: "0px",
                            minWidth: "44px",
                        }}
                    >
                        <FontAwesomeIcon icon={faMagnifyingGlass} />
                    </BlueHoverButton>
                </div>

                {pontosBuscados && (
                    <div style={{ padding: "0 12px 10px 12px", position: "relative", zIndex: 10 }}>
                        <InputLabel sx={{ color: "#b8b8b8", fontSize: "12px", fontWeight: 600, marginBottom: "4px" }}>
                            Ocupante
                        </InputLabel>
                        <OcupantesSearchField
                            field={{
                                value: ocupanteSelecionado,
                                onChange: handleOcupanteChange,
                            }}
                            id="ocupante-mapa"
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 99999 }),
                            }}
                        />
                    </div>
                )}

                <div style={{ marginLeft: "18px", padding: "10px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px" }}>
                        <div style={{ width: 20, height: 20, backgroundColor: "#008000", borderRadius: "50%", flexShrink: 0 }} />
                        <span style={{ color: "#b8b8b8", fontSize: "14px", minWidth: "150px" }}>Disponível</span>
                        <span style={{ color: "#b8b8b8", fontSize: "14px", whiteSpace: "nowrap", marginLeft: "45px" }}>Rede Secundária</span>
                        <div style={{ width: 40, borderBottom: "3px solid #808080", flexShrink: 0 }} />
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px" }}>
                        <div style={{ width: 20, height: 20, backgroundColor: "#FF0000", borderRadius: "50%", flexShrink: 0 }} />
                        <span style={{ color: "#b8b8b8", fontSize: "14px", minWidth: "150px" }}>Indisponível</span>
                        <span style={{ color: "#b8b8b8", fontSize: "14px", whiteSpace: "nowrap", marginLeft: "45px" }}>Rede Primária</span>
                        <div style={{ width: 40, borderBottom: "3px solid black", flexShrink: 0, marginLeft: "18px" }} />
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <div style={{ width: 20, height: 20, backgroundColor: "#FF8C00", borderRadius: "50%", flexShrink: 0 }} />
                        <span style={{ color: "#b8b8b8", fontSize: "14px", minWidth: "150px", whiteSpace: "nowrap" }}>
                            Em uso pelo ocupante
                        </span>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "12px" }}>
                        <div style={{ width: 20, height: 20, backgroundColor: "#8B0000", borderRadius: "50%", flexShrink: 0 }} />
                        <span style={{ color: "#b8b8b8", fontSize: "14px", minWidth: "150px", whiteSpace: "nowrap" }}>
                            Indisponível (já utilizado pelo ocupante)
                        </span>
                    </div>
                </div>

                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gap: '15px',
                        backgroundColor: '#1e1e1e',
                        width: '100%',
                        borderTop: '1px solid #444',
                        boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.05)',
                        marginTop: '12px',
                        borderRadius: '6px',
                        padding: '10px 8px',
                        opacity: 1
                    }}
                >
                    {/* <BlueHoverButton
                        onClick={handleConsultarPontos}
                        style={{
                            backgroundColor: '#000',
                            color: '#fff',
                            padding: '10px',
                            borderRadius: '6px',
                            border: 'none',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                        }}
                        title="Consultar disponibilidade"
                    >
                        <GrSearch size={26} />
                    </BlueHoverButton> */}

                    <BlueHoverButton
                        onClick={ativarModoDesenho}
                        className={modoAtivo === 'desenho' ? 'botao-ativo' : ''}
                        style={{
                            backgroundColor: '#000',
                            color: '#fff',
                            padding: '10px',
                            borderRadius: '6px',
                            border: 'none',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        title="Desenho"
                    >
                        <FaDrawPolygon size={26} />
                    </BlueHoverButton>

                    {/* <BlueHoverButton
                        onClick={handleUndoPonto}
                        style={{
                            backgroundColor: '#000',
                            color: '#fff',
                            padding: '10px',
                            borderRadius: '6px',
                            border: 'none',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                        }}
                        title="Desfazer último ponto"
                    >
                        <CiUndo size={26} />
                    </BlueHoverButton> */}

                    <BlueHoverButton
                        onClick={ativarModoMao}
                        className={modoAtivo === 'mao' ? 'botao-ativo' : ''}
                        style={{
                            backgroundColor: '#000',
                            border: 'none',
                            borderRadius: '6px',
                            padding: '10px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        title="Parar de desenhar"
                    >
                        <FaHandPaper size={26} />
                    </BlueHoverButton>

                    <BlueHoverButton
                        onClick={() => setOpenDialogMessageClearMap(true)}
                        className="red-hover-button"
                        style={{
                            backgroundColor: '#000',
                            color: '#fff',
                            padding: '10px',
                            borderRadius: '6px',
                            border: 'none',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                        }}
                        title="Limpar mapa"
                    >
                        <TbMapX size={26} />
                    </BlueHoverButton>
                </div>
            </div>)}

            <Snackbar open={open} style={{ top: 78 }} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                    {errorMessage}
                </Alert>
            </Snackbar>

            <Dialog
                open={openDialogMessageClearMap}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    '& .MuiPaper-root': {
                        backgroundColor: "#232323",
                        color: "whitesmoke",
                        padding: "20px",
                        borderRadius: "10px",
                        width: "400px"
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title" sx={{ fontWeight: "bold", alignContent: "center", fontSize: "18px" }}>
                    {"Atenção!"}
                </DialogTitle>
                <DialogContent id="alert-dialog-description" sx={{ fontSize: "14px" }}>
                    Todos os pontos adicionados serão removidos do mapa. <strong>Deseja realmente limpar o mapa?</strong>
                </DialogContent>
                <DialogActions>
                    <BlueHoverButton
                        autoFocus
                        onClick={handleLimparMapa}
                    >
                        Continuar
                    </BlueHoverButton>
                    <BlueHoverButton
                        onClick={handleCloseDialog}>Cancelar</BlueHoverButton>
                </DialogActions>
            </Dialog>

            {showDrawing && (
                <MapaDrawingManager
                    drawingManagerKey={drawingManagerKey}
                    polyRef={polyRef}
                    setPoligono={setPoligono}
                    drawingManagerRef={drawingManagerRef}
                    handleConsultarPontos={handleConsultarPontos}
                    handleLimparMapa={handleLimparMapa}
                    setModoAtivo={setModoAtivo}
                    modoAtivo={modoAtivo}
                />
            )}
            <Modal open={isLoading}>
                <Box style={modalstyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
        </GoogleMap>
    )
}

export default MapaDrawing;